export const COOKIE_CONSENT_STORAGE_KEY = "cookie_consent";

export type CookieConsent = "all" | "essential";

export interface ConsentStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

type ConsentStorageSource = ConsentStorage | (() => ConsentStorage);

interface AnalyticsConsentDecision {
  consent: CookieConsent | null;
  analyticsOptIn: boolean | null | undefined;
  eventType: string;
}

function resolveStorage(source: ConsentStorageSource): ConsentStorage {
  return typeof source === "function" ? source() : source;
}

export function readCookieConsent(source: ConsentStorageSource): CookieConsent | null {
  try {
    const value = resolveStorage(source).getItem(COOKIE_CONSENT_STORAGE_KEY);
    return value === "all" || value === "essential" ? value : null;
  } catch {
    return null;
  }
}

export function writeCookieConsent(
  source: ConsentStorageSource,
  value: CookieConsent,
): boolean {
  try {
    resolveStorage(source).setItem(COOKIE_CONSENT_STORAGE_KEY, value);
    return true;
  } catch {
    return false;
  }
}

export function hasExplicitAnalyticsConsent(source: ConsentStorageSource): boolean {
  return readCookieConsent(source) === "all";
}

export function canTrackAnalytics({
  consent,
  analyticsOptIn,
  eventType: _eventType,
}: AnalyticsConsentDecision): boolean {
  return consent === "all" && analyticsOptIn !== false;
}
